import { Button } from "react-bootstrap";

function BtnSize() {
  return (
    <>
        <div className="col-md-5">
            <h4 className="card-title">Button Size</h4>
            <p className="card-description">Use class <code>.btn-&#123;size&#125;</code></p>
            <div className="template-demo">
              <Button variant="outline-secondary btn-lg">btn-lg</Button>
              <Button variant="outline-secondary btn-md">btn-md</Button>
              <Button variant="outline-secondary btn-sm">btn-sm</Button>
              </div>
            <div className="template-demo mt-4">
              <Button variant="danger btn-lg">btn-lg</Button>
              <Button variant="success btn-md">btn-md</Button>
              <Button variant="primary btn-sm">btn-sm</Button>
            </div>
        </div>
    </>
  )
}

export default BtnSize